(function () {
  'use strict';

  function initialiseMagnifier(root) {
    if (!root || root.dataset.magnifierReady === 'true') return;

    var stage = root.querySelector('.mosaic-magnifier__stage');
    var image = root.querySelector('.mosaic-magnifier__image');
    var lens = root.querySelector('.mosaic-magnifier__lens');

    if (!stage || !image || !lens) return;

    root.dataset.magnifierReady = 'true';

    function isMobileBlocked(event) {
      var mobileEnabled = root.dataset.enableMobile === 'true';

      var touchEvent =
        event.pointerType === 'touch' ||
        event.type.indexOf('touch') === 0;

      return (
        !mobileEnabled &&
        (
          touchEvent ||
          window.matchMedia('(max-width: 749px)').matches
        )
      );
    }

    function hideLens() {
      stage.classList.remove('is-active');
      lens.style.opacity = '0';
      lens.style.visibility = 'hidden';
    }

    function moveLens(event) {
      if (isMobileBlocked(event)) {
        hideLens();
        return;
      }

      var point =
        event.touches && event.touches[0]
          ? event.touches[0]
          : event;

      var rect = image.getBoundingClientRect();

      if (!rect.width || !rect.height) return;

      var x = Math.max(
        0,
        Math.min(point.clientX - rect.left, rect.width)
      );

      var y = Math.max(
        0,
        Math.min(point.clientY - rect.top, rect.height)
      );

      var lensWidth = lens.offsetWidth;
      var lensHeight = lens.offsetHeight;

      var zoom = Math.max(
        1.5,
        Number(root.dataset.zoom) || 3
      );

      var source = image.currentSrc || image.src;

      if (!lensWidth || !lensHeight) {
        lensWidth = Math.max(
          120,
          Number(root.dataset.lensSize) || 260
        );

        lensHeight = lensWidth;
      }

      lens.style.backgroundImage =
        'url("' + source.replace(/"/g, '%22') + '")';

      lens.style.backgroundSize =
        rect.width * zoom +
        'px ' +
        rect.height * zoom +
        'px';

      lens.style.backgroundPosition =
        lensWidth / 2 -
        x * zoom +
        'px ' +
        (
          lensHeight / 2 -
          y * zoom
        ) +
        'px';

      lens.style.position = 'absolute';
      lens.style.display = 'block';
      lens.style.zIndex = '999';

      lens.style.width = lensWidth + 'px';
      lens.style.height = lensHeight + 'px';

      lens.style.left = x + 'px';
      lens.style.top = y + 'px';

      lens.style.transform =
        'translate(-50%, -50%)';

      lens.style.opacity = '1';
      lens.style.visibility = 'visible';

      stage.style.cursor = 'zoom-in';
      stage.classList.add('is-active');
    }

    stage.addEventListener(
      'mouseenter',
      moveLens
    );

    stage.addEventListener(
      'mousemove',
      moveLens
    );

    stage.addEventListener(
      'mouseleave',
      hideLens
    );

    stage.addEventListener(
      'touchstart',
      moveLens,
      {
        passive: true
      }
    );

    stage.addEventListener(
      'touchmove',
      moveLens,
      {
        passive: true
      }
    );

    stage.addEventListener(
      'touchend',
      hideLens
    );

    image.addEventListener(
      'load',
      hideLens
    );
  }

  function initialiseAll(scope) {
    var container = scope || document;

    if (
      container.matches &&
      container.matches('.mosaic-magnifier')
    ) {
      initialiseMagnifier(container);
    }

    var roots = container.querySelectorAll
      ? container.querySelectorAll('.mosaic-magnifier')
      : [];

    Array.prototype.forEach.call(
      roots,
      initialiseMagnifier
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initialiseAll(document);
      }
    );
  } else {
    initialiseAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialiseAll(event.target);
    }
  );
})();